import {
  OPERATOR_PRE_ONBOARDING_START,
  OPERATOR_PRE_ONBOARDING_SUCCESS,
  OPERATOR_PRE_ONBOARDING_ERROR,
  OPERATOR_PRE_ONBOARDING_SEND_BACK_REVIEW_START,
  OPERATOR_PRE_ONBOARDING_SEND_BACK_REVIEW_SUCCESS,
  OPERATOR_PRE_ONBOARDING_SEND_BACK_REVIEW_ERROR,
  OPERATOR_GET_PRE_ONBOARDING_DATA_START,
  OPERATOR_GET_PRE_ONBOARDING_DATA_SUCCESS,
  OPERATOR_GET_PRE_ONBOARDING_DATA_ERROR,
  OPERATOR_FIRST_TIME_GET_ONBOARDING_DATA_START,
  OPERATOR_FIRST_TIME_GET_ONBOARDING_DATA_SUCCESS,
  OPERATOR_FIRST_TIME_GET_ONBOARDING_DATA_ERROR,
  OPERATOR_ONBOARDING_ACCOUNT_SETUP_DATA_START,
  OPERATOR_ONBOARDING_ACCOUNT_SETUP_DATA_SUCCESS,
  OPERATOR_ONBOARDING_ACCOUNT_SETUP_DATA_ERROR,
  TEARM_AND_CANCEL_POLICY_SUCCESS,
  TEARM_AND_CANCEL_POLICY_ERROR,
  OPERATOR_ONBOARDING_BUSSINESS_INFO_START,
  OPERATOR_ONBOARDING_BUSSINESS_INFO_SUCCESS,
  OPERATOR_ONBOARDING_BUSSINESS_INFO_ERROR,
  OPERATOR_ONBOARDING_BANK_ACCOUNT_TAX_START,
  OPERATOR_ONBOARDING_BANK_ACCOUNT_TAX_SUCCESS,
  OPERATOR_ONBOARDING_BANK_ACCOUNT_TAX_ERROR,
  GET_REGISTARATION_DETAILS_FROM_CHASIS_START,
  GET_REGISTARATION_DETAILS_FROM_CHASIS_SUCCESS,
  GET_REGISTARATION_DETAILS_FROM_CHASIS_ERROR,
  OPERATOR_BULK_VAS_UPLOAD_START,
  OPERATOR_BULK_VAS_UPLOAD_SUCCESS,
  OPERATOR_BULK_VAS_UPLOAD_ERROR,
  GET_TOURS_START,
  GET_TOURS_SUCCESS,
  GET_TOURS_ERROR,
  ADD_TOURS_START,
  ADD_TOURS_SUCCESS,
  ADD_TOURS_ERROR,
  EDIT_TOURS_START,
  EDIT_TOURS_SUCCESS,
  EDIT_TOURS_ERROR,
  DELETE_TOURS_START,
  DELETE_TOURS_SUCCESS,
  DELETE_TOURS_ERROR,
  ADD_VAS_START,
  ADD_VAS_SUCCESS,
  ADD_VAS_ERROR,
  EDIT_VAS_START,
  EDIT_VAS_SUCCESS,
  EDIT_VAS_ERROR,
  GET_VAS_START,
  GET_VAS_SUCCESS,
  GET_VAS_ERROR,
  DELETE_VAS_START,
  DELETE_VAS_SUCCESS,
  DELETE_VAS_ERROR,
  ADD_MOTORCYCLE_START,
  ADD_MOTORCYCLE_SUCCESS,
  ADD_MOTORCYCLE_ERROR,
  GET_MOTORCYCLE_START,
  GET_MOTORCYCLE_SUCCESS,
  GET_MOTORCYCLE_ERROR,
  DELETE_MOTORCYCLE_START,
  DELETE_MOTORCYCLE_SUCCESS,
  DELETE_MOTORCYCLE_ERROR,
  GET_MOTORCYCLE_LOCATION_START,
  GET_MOTORCYCLE_LOCATION_SUCCESS,
  GET_MOTORCYCLE_LOCATION_ERROR,
  UPLOAD_BULK_MOTORCYCLE_START,
  UPLOAD_BULK_MOTORCYCLE_SUCCESS,
  UPLOAD_BULK_MOTORCYCLE_ERROR,
  STATE_LIST_SUCCESS,
  STATE_LIST_ERROR,
  ONBOARDING_FORM_DATA_FIELD,
  BANK_TAX_ACCOUNT_DETAIL,
  ONBOARDING_BUSISINESS_DETAIL_DATA,
  ONBOARDING_CANCEL_POLICY,
  CLEAR_CHASSIS_NO_DATA,
  CHECK_VALIDATE_DATA_ACCOUNTDETAIL,
  CHECK_VALIDATE_DATA_BUSSINACEDETAIL,
  CHECK_VALIDATE_DATA_BANKTAXDETAIL,
  CHECK_VALIDATE_DATA_CANCELPOLICYDATA,
} from "Constant";

const initialState = {
  loading: false,
  accountSetupLoading: false,
  data: [],
  getToursData: [],
  getToursLoading: false,
  addToursLoading: false,
  deleteTours: [],
  addVasLoading: false,
  addVasData: [],
  getVasData: [],
  getVasLoading: false,
  getPreOnboardingData: [],
  sendBackToReview: null,
  firstTimeOnboardingData: [],
  termCancelAndPolicy: [],
  accountSetUpData: [],
  bussinessInfo: [],
  bussinessInfoLoading: false,
  bankAccountInfo: [],
  bankAccountLoading: false,
  getRegisrationDetailsFromChasis: [],
  uploadBulkVAS: [],
  bulkVasLoading: false,
  deleteVas: [],
  motorcycleLoading: false,
  addMotorcycle: [],
  getMotorcycleLocationData: [],
  mlocationLoading: false,
  getMotorcycleData: [],
  deleteMotorcycle: [],
  uploadBulkMotorcycle: [],
  stateList: [],
  firstTimeBussinaceInfo: null,
  firstTimeBankTaxInfo: null,
  isAllAccountFieldFill: true,
  isAllBussincFieldFill: true,
  isAllBankAccountTaxFieldFill: true,
  isAllCancelPolicyFieldFill: true,
};

export default function PreOnBoardingReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case STATE_LIST_SUCCESS:
      return {
        ...state,
        stateList: action.payload,
        loading: false,
      };
    case STATE_LIST_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case OPERATOR_PRE_ONBOARDING_START:
      return {
        ...state,
        loading: true,
      };
    case OPERATOR_PRE_ONBOARDING_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case OPERATOR_PRE_ONBOARDING_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case OPERATOR_PRE_ONBOARDING_SEND_BACK_REVIEW_START:
      return {
        ...state,
        loading: true,
      };
    case OPERATOR_PRE_ONBOARDING_SEND_BACK_REVIEW_SUCCESS:
      return {
        ...state,
        sendBackToReview: action.payload,
        loading: false,
      };
    case OPERATOR_PRE_ONBOARDING_SEND_BACK_REVIEW_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case OPERATOR_GET_PRE_ONBOARDING_DATA_START:
      return {
        ...state,
        loading: true,
      };
    case OPERATOR_GET_PRE_ONBOARDING_DATA_SUCCESS:
      return {
        ...state,
        getPreOnboardingData: action.payload,
        loading: false,
      };
    case OPERATOR_GET_PRE_ONBOARDING_DATA_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case OPERATOR_FIRST_TIME_GET_ONBOARDING_DATA_START:
      return {
        ...state,
        loading: true,
        isDataFetching: false,
      };
    case OPERATOR_FIRST_TIME_GET_ONBOARDING_DATA_SUCCESS:
      return {
        ...state,
        firstTimeOnboardingData: action.payload,
        firstTimeBussinaceInfo:
          action.payload?.requestDetails?.operatorBusinessInfo,
        firstTimeBankTaxInfo: action.payload?.requestDetails?.bankAndTaxDetails,
        isDataFetching: true,
        loading: false,
      };
    case OPERATOR_FIRST_TIME_GET_ONBOARDING_DATA_ERROR:
      return {
        ...state,
        loading: false,
        isDataFetching: false,
        message: action.error.message,
      };
    case OPERATOR_ONBOARDING_ACCOUNT_SETUP_DATA_START:
      return {
        ...state,
        accountSetupLoading: true,
      };
    case OPERATOR_ONBOARDING_ACCOUNT_SETUP_DATA_SUCCESS:
      return {
        ...state,
        accountSetUpData: action.payload,
        accountSetupLoading: false,

        firstTimeOnboardingData: action.payload,
        firstTimeBussinaceInfo:
          action.payload?.requestDetails?.operatorBusinessInfo,
        firstTimeBankTaxInfo: action.payload?.requestDetails?.bankAndTaxDetails,
        isDataFetching: true,
        loading: false,
      };
    case OPERATOR_ONBOARDING_ACCOUNT_SETUP_DATA_ERROR:
      return {
        ...state,
        accountSetupLoading: false,
        message: action.error.message,
      };
    case TEARM_AND_CANCEL_POLICY_SUCCESS:
      return {
        ...state,
        termCancelAndPolicy: action.payload,
        accountSetupLoading: false,
      };
    case TEARM_AND_CANCEL_POLICY_ERROR:
      return {
        ...state,
        accountSetupLoading: false,
        message: action.error.message,
      };
    case OPERATOR_ONBOARDING_BUSSINESS_INFO_START:
      return {
        ...state,
        bussinessInfoLoading: true,
      };
    case OPERATOR_ONBOARDING_BUSSINESS_INFO_SUCCESS:
      return {
        ...state,
        bussinessInfo: action.payload,
        bussinessInfoLoading: false,
      };
    case OPERATOR_ONBOARDING_BUSSINESS_INFO_ERROR:
      return {
        ...state,
        bussinessInfoLoading: false,
        message: action.error.message,
      };
    case OPERATOR_ONBOARDING_BANK_ACCOUNT_TAX_START:
      return {
        ...state,
        bankAccountLoading: true,
      };
    case OPERATOR_ONBOARDING_BANK_ACCOUNT_TAX_SUCCESS:
      return {
        ...state,
        bankAccountInfo: action.payload,
        bankAccountLoading: false,
      };
    case OPERATOR_ONBOARDING_BANK_ACCOUNT_TAX_ERROR:
      return {
        ...state,
        bankAccountLoading: false,
        message: action.error.message,
      };
    case OPERATOR_BULK_VAS_UPLOAD_START:
      return {
        ...state,
        bulkVasLoading: true,
      };
    case OPERATOR_BULK_VAS_UPLOAD_SUCCESS:
      return {
        ...state,
        uploadBulkVAS: action.payload,
        bulkVasLoading: false,
      };
    case OPERATOR_BULK_VAS_UPLOAD_ERROR:
      return {
        ...state,
        bulkVasLoading: false,
        message: action.error.message,
      };
    case GET_REGISTARATION_DETAILS_FROM_CHASIS_START:
      return {
        ...state,
        loading: true,
      };
    case GET_REGISTARATION_DETAILS_FROM_CHASIS_SUCCESS:
      return {
        ...state,
        getRegisrationDetailsFromChasis: action.payload,
        loading: false,
      };
    case GET_REGISTARATION_DETAILS_FROM_CHASIS_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };

    case GET_TOURS_START:
      return {
        ...state,
        getToursLoading: true,
      };
    case GET_TOURS_SUCCESS:
      return {
        ...state,
        getToursData: action.payload,
        getToursLoading: false,
      };
    case GET_TOURS_ERROR:
      return {
        ...state,
        getToursLoading: false,
        message: action.error.message,
      };
    case ADD_TOURS_START:
      return {
        ...state,
        addToursLoading: true,
      };
    case ADD_TOURS_SUCCESS:
      return {
        ...state,
        addToursData: action.payload,
        addToursLoading: false,
      };
    case ADD_TOURS_ERROR:
      return {
        ...state,
        addToursLoading: false,
        message: action.error.message,
      };
    case EDIT_TOURS_START:
      return {
        ...state,
        addToursLoading: true,
      };
    case EDIT_TOURS_SUCCESS:
      return {
        ...state,
        addToursData: action.payload,
        addToursLoading: false,
      };
    case EDIT_TOURS_ERROR:
      return {
        ...state,
        addToursLoading: false,
        message: action.error.message,
      };

    case DELETE_TOURS_START:
      return {
        ...state,
        getToursLoading: true,
      };
    case DELETE_TOURS_SUCCESS:
      return {
        ...state,
        deleteTours: action.payload,
        getToursLoading: false,
      };
    case DELETE_TOURS_ERROR:
      return {
        ...state,
        getToursLoading: false,
        message: action.error.message,
      };

    case ADD_VAS_START:
      return {
        ...state,
        addVasLoading: true,
      };
    case ADD_VAS_SUCCESS:
      return {
        ...state,
        addVasData: action.payload,
        addVasLoading: false,
      };
    case ADD_VAS_ERROR:
      return {
        ...state,
        addVasLoading: false,
        message: action.error.message,
      };
    case EDIT_VAS_START:
      return {
        ...state,
        addVasLoading: true,
      };
    case EDIT_VAS_SUCCESS:
      return {
        ...state,
        addVasData: action.payload,
        addVasLoading: false,
      };
    case EDIT_VAS_ERROR:
      return {
        ...state,
        addVasLoading: false,
        message: action.error.message,
      };
    case GET_VAS_START:
      return {
        ...state,
        getVasLoading: true,
      };
    case GET_VAS_SUCCESS:
      return {
        ...state,
        getVasData: action.payload,
        getVasLoading: false,
      };
    case GET_VAS_ERROR:
      return {
        ...state,
        getVasLoading: false,
        message: action.error.message,
      };
    case DELETE_VAS_START:
      return {
        ...state,
        getVasLoading: true,
      };
    case DELETE_VAS_SUCCESS:
      return {
        ...state,
        deleteVas: action.payload,
        getVasLoading: false,
      };
    case DELETE_VAS_ERROR:
      return {
        ...state,
        getVasLoading: false,
        message: action.error.message,
      };
    case ADD_MOTORCYCLE_START:
      return {
        ...state,
        mlocationLoading: true,
      };
    case ADD_MOTORCYCLE_SUCCESS:
      return {
        ...state,
        addMotorcycle: action.payload,
        mlocationLoading: false,
      };
    case ADD_MOTORCYCLE_ERROR:
      return {
        ...state,
        mlocationLoading: false,
        message: action.error.message,
      };
    case GET_MOTORCYCLE_START:
      return {
        ...state,
        loading: true,
      };
    case GET_MOTORCYCLE_SUCCESS:
      return {
        ...state,
        getMotorcycleData: action.payload,
        loading: false,
      };
    case GET_MOTORCYCLE_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case DELETE_MOTORCYCLE_START:
      return {
        ...state,
        loading: true,
      };
    case DELETE_MOTORCYCLE_SUCCESS:
      return {
        ...state,
        deleteMotorcycle: action.payload,
        loading: false,
      };
    case DELETE_MOTORCYCLE_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case GET_MOTORCYCLE_LOCATION_START:
      return {
        ...state,
        motorcycleLoading: true,
      };
    case GET_MOTORCYCLE_LOCATION_SUCCESS:
      return {
        ...state,
        getMotorcycleLocationData: action.payload,
        motorcycleLoading: false,
      };
    case GET_MOTORCYCLE_LOCATION_ERROR:
      return {
        ...state,
        motorcycleLoading: false,
        message: action.error.message,
      };
    case UPLOAD_BULK_MOTORCYCLE_START:
      return {
        ...state,
        motorcycleLoading: true,
      };
    case UPLOAD_BULK_MOTORCYCLE_SUCCESS:
      return {
        ...state,
        uploadBulkMotorcycle: action.payload,
        motorcycleLoading: false,
      };
    case UPLOAD_BULK_MOTORCYCLE_ERROR:
      return {
        ...state,
        motorcycleLoading: false,
        message: action.error.message,
      };
    case ONBOARDING_FORM_DATA_FIELD:
      const { firstTimeOnboardingData } = { ...state };
      if (action.payload.field) {
        firstTimeOnboardingData.requestDetails.accountDetails[
          action.payload.field
        ][action.payload.name] = action.payload.data;
      } else {
        firstTimeOnboardingData.requestDetails.accountDetails[
          action.payload.name
        ].value = action.payload.data;
      }

      return {
        ...state,
        firstTimeOnboardingData: firstTimeOnboardingData,
        motorcycleLoading: false,
      };
    case BANK_TAX_ACCOUNT_DETAIL:
      const { firstTimeOnboardingData: bankTaxDataValue } = { ...state };
      if (!bankTaxDataValue.requestDetails["bankAndTaxDetails"]) {
        bankTaxDataValue.requestDetails["bankAndTaxDetails"] = {};
      }
      if (action.payload.field) {
        if (
          !bankTaxDataValue.requestDetails["bankAndTaxDetails"][
            action.payload.field
          ]
        ) {
          bankTaxDataValue.requestDetails["bankAndTaxDetails"][
            action.payload.field
          ] = {};
        }
        bankTaxDataValue.requestDetails["bankAndTaxDetails"][
          action.payload.field
        ][action.payload.name] = action.payload.data;
      } else {
        if (
          !bankTaxDataValue.requestDetails["bankAndTaxDetails"][
            action.payload.name
          ]
        ) {
          bankTaxDataValue.requestDetails["bankAndTaxDetails"][
            action.payload.name
          ] = {};
        }
        bankTaxDataValue.requestDetails["bankAndTaxDetails"][
          action.payload.name
        ]["value"] = action.payload.data;
      }

      return {
        ...state,
        firstTimeOnboardingData: bankTaxDataValue,
        motorcycleLoading: false,
      };

    case ONBOARDING_BUSISINESS_DETAIL_DATA:
      const { firstTimeOnboardingData: bussinaceDataValue } = {
        ...state,
      };
      if (!bussinaceDataValue.requestDetails["operatorBusinessInfo"]) {
        bussinaceDataValue.requestDetails["operatorBusinessInfo"] = {};
      }
      if (action.payload.name === "commercialLicencePath") {
        if (action.payload.field) {
          bussinaceDataValue.requestDetails["operatorBusinessInfo"][
            "commercialLicencePath"
          ] = action.payload.data;
        } else {
          bussinaceDataValue.requestDetails["operatorBusinessInfo"][
            "commercialLicencePath"
          ] = bussinaceDataValue.requestDetails["operatorBusinessInfo"][
            "commercialLicencePath"
          ]
            ? [
                ...bussinaceDataValue.requestDetails["operatorBusinessInfo"][
                  "commercialLicencePath"
                ],
                action.payload.data,
              ]
            : [action.payload.data];
        }
      } else if (action.payload.name === "businessPartner") {
        if (
          !bussinaceDataValue.requestDetails["operatorBusinessInfo"][
            "businessPartner"
          ]
        ) {
          bussinaceDataValue.requestDetails["operatorBusinessInfo"][
            "businessPartner"
          ] = {};
        }
        bussinaceDataValue.requestDetails["operatorBusinessInfo"][
          "businessPartner"
        ]["partners"] = action.payload.data;
        // console.log(bussinaceDataValue.requestDetails['operatorBusinessInfo']['businessPartner']['partners'])
      } else if (action.payload.name === "locations") {
        bussinaceDataValue.requestDetails["operatorBusinessInfo"]["locations"] =
          action.payload.data;
      } else if (action.payload.name === "images") {
        if (action.payload.data) {
          bussinaceDataValue.requestDetails["operatorBusinessInfo"]["images"] =
            [action.payload.data];
        } else {
          bussinaceDataValue.requestDetails["operatorBusinessInfo"]["images"] =
            [];
        }
      } else if (action.payload.name === "users") {
        if (
          !bussinaceDataValue.requestDetails["operatorBusinessInfo"]["users"]
        ) {
          bussinaceDataValue.requestDetails["operatorBusinessInfo"]["users"] =
            {};
        }
        if (
          !bussinaceDataValue.requestDetails["operatorBusinessInfo"]["users"][
            action.payload.field
          ]
        ) {
          bussinaceDataValue.requestDetails["operatorBusinessInfo"]["users"][
            action.payload.field
          ] = {};
        }
        bussinaceDataValue.requestDetails["operatorBusinessInfo"]["users"][
          action.payload.field
        ][action.payload.value] = action.payload.data;
      } else if (action.payload.field) {
        if (
          !bussinaceDataValue.requestDetails["operatorBusinessInfo"][
            action.payload.field
          ]
        ) {
          bussinaceDataValue.requestDetails["operatorBusinessInfo"][
            action.payload.field
          ] = {};
        }
        bussinaceDataValue.requestDetails["operatorBusinessInfo"][
          action.payload.field
        ][action.payload.name] = action.payload.data;
      } else {
        if (
          !bussinaceDataValue.requestDetails["operatorBusinessInfo"][
            action.payload.name
          ]
        ) {
          bussinaceDataValue.requestDetails["operatorBusinessInfo"][
            action.payload.name
          ] = {};
        }
        bussinaceDataValue.requestDetails["operatorBusinessInfo"][
          action.payload.name
        ]["value"] = action.payload.data;
      }

      return {
        ...state,
        firstTimeOnboardingData: bussinaceDataValue,
        motorcycleLoading: false,
        isDataFetching: false,
      };

    case ONBOARDING_CANCEL_POLICY:
      const { firstTimeOnboardingData: cancelPolicyDetail } = {
        ...state,
      };
      if (action.payload.name === "termsAndPolicy") {
        if (action.payload.field === "timeFrames") {
          if (
            !cancelPolicyDetail.requestDetails["operatorTermsAndPolicy"][
              "termsAndPolicy"
            ]
          ) {
            cancelPolicyDetail.requestDetails["operatorTermsAndPolicy"][
              "termsAndPolicy"
            ] = {};
          }
          cancelPolicyDetail.requestDetails["operatorTermsAndPolicy"][
            "termsAndPolicy"
          ][action.payload.field] = action.payload.data;
        } else {
          if (
            !cancelPolicyDetail.requestDetails["operatorTermsAndPolicy"][
              "termsAndPolicy"
            ]["lateReturnPolicy"]
          ) {
            cancelPolicyDetail.requestDetails["operatorTermsAndPolicy"][
              "termsAndPolicy"
            ]["lateReturnPolicy"] = {};
          }
          cancelPolicyDetail.requestDetails["operatorTermsAndPolicy"][
            "termsAndPolicy"
          ]["lateReturnPolicy"][action.payload.value] = action.payload.data;
        }
      }

      return {
        ...state,
        firstTimeOnboardingData: cancelPolicyDetail,
        motorcycleLoading: false,
      };
    case CLEAR_CHASSIS_NO_DATA:
      return {
        ...state,
        getRegisrationDetailsFromChasis: action.payload,
        loading: false,
      };
    case CHECK_VALIDATE_DATA_ACCOUNTDETAIL:
      return {
        ...state,
        isAllAccountFieldFill: action.payload,
        loading: false,
      };
    case CHECK_VALIDATE_DATA_BUSSINACEDETAIL:
      return {
        ...state,
        isAllBussincFieldFill: action.payload,
        loading: false,
      };
    case CHECK_VALIDATE_DATA_BANKTAXDETAIL:
      return {
        ...state,
        isAllBankAccountTaxFieldFill: action.payload,
        loading: false,
      };
    case CHECK_VALIDATE_DATA_CANCELPOLICYDATA:
      return {
        ...state,
        isAllCancelPolicyFieldFill: action.payload,
        loading: false,
      };

    default:
      return state;
  }
}
